import { z } from 'zod';
import create from 'zustand';
import { persist } from 'zustand/middleware';

import { PRISMA_COMPANY_ID } from '@/constants/enums';

import { tickerSchema } from '@irm/schemas';

export type ViewType = 'prisma' | 'company';
export type Ticker = z.infer<typeof tickerSchema>;

type RoleState = {
  view: ViewType;
  company: string | undefined;
  tickers: Ticker[];
  setCompany: (companyId: string) => void;
  setTickers: (tickers: Ticker[]) => void;
};

export const useViewStore = create(
  persist<RoleState>(
    (set) => {
      const setCompany = (company: string) =>
        set((state) => {
          let view: ViewType = `company`;

          if (company === PRISMA_COMPANY_ID) {
            view = `prisma`;
          }

          return { ...state, view, company };
        });
      const setTickers = (tickers: Ticker[]) =>
        set((state) => ({
          ...state,
          tickers,
        }));

      return {
        view: `prisma`,
        company: undefined,
        tickers: [],
        setCompany,
        setTickers,
      };
    },
    { name: `layout-view` },
  ),
);
